import React from 'react';
import Table from "src/componets/Table";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { ColumnsType } from "antd/es/table";
import { ButtonEdit, ButtonDestroy } from "src/componets/Buttons";
import { setEditId, AdminRecordInterface } from "src/store/watcher/adminsSlice";
import { destroyAdmin } from "src/actions/watcher/adminsActions";
import { roleToLabel } from "src/helpers/RoleHelper";
import { EntityId } from "@reduxjs/toolkit";

import { message, Avatar, Space, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";

const ROLE_COLORS: Record<string, string | undefined> = {
  admin: 'orange',
  manager: 'blue',
  developer: undefined
};

const _ListTable = () => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => state.watcher.admins.ids);
  const admins = useAppSelector(state => state.watcher.admins.entities);
  const currentAdminId = useAppSelector(state => state.session.admin.id);
  const data = ids ? ids.map(id => admins[id]) : [];

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  async function onClickDestroy(id: number) {
    const resultAction = await dispatch(destroyAdmin(id));

    if (destroyAdmin.fulfilled.match(resultAction)) {
      message.success('Admin deleted');
    } else {
      const payload: any = resultAction.payload;
      const errors = payload?.errors || payload;
      message.error(Array.isArray(errors) ? errors[0] : 'Failed to delete admin');
    }
  }

  const columns: ColumnsType<AdminRecordInterface> = [
    {
      key: 'avatar_url',
      title: '',
      dataIndex: 'avatar_url',
      render: (_, { avatar_url }) => {
        return <Avatar
          src={avatar_url}
          alt='Admin avatar'
          size={32}
          icon={<UserOutlined />}
          shape='square'
        />
      },
      width: 50
    },

    {
      key: 'username',
      title: 'Username',
      render: (_, { username }) => username,
      width: 135,
      ellipsis: true
    },

    {
      key: 'email',
      title: 'Email',
      render: (_, { email }) => <small>{email}</small>,
      width: 180,
      ellipsis: true
    },

    {
      key: 'role',
      title: 'Role',
      render: (_, { role }) => <Tag color={ROLE_COLORS[role]}>{roleToLabel(role)}</Tag>,
      width: 100
    },

    {
      key: 'action',
      title: 'Action',
      render: (_, { id }) => {
        return (
          <Space size="middle">
            <ButtonEdit key='button-edit' onClick={() => onClickEdit(id)} />
            {id !== currentAdminId && (
              <ButtonDestroy key='button-destroy' onClick={() => onClickDestroy(id)} />
            )}
          </Space>
        );
      },
      width: 140
    },
  ];

  return (
    <Table
      rowKey='id'
      columns={columns}
      dataSource={data}
    />
  )
}

export default _ListTable;
